import { Modal } from "react-bootstrap";

const DocumentModal = (props) => {	
	// console.log("docProps:", props);
	return (
		<>
			<Modal
				{...props}
				size="lg"
				aria-labelledby="contained-modal-title-vcenter"
				centered
			>
				<Modal.Header closeButton>
					<Modal.Title id="contained-modal-title-vcenter">{ props.heading}</Modal.Title>
				</Modal.Header>
				{props.children}
			</Modal>
		</>
	);
};

export default DocumentModal;
